import Vue from 'vue';
import '../src/plugins/index';
import App from './App.vue';
import router from './router';
import store from './store';
import Layout from '@/assets/styles/components';
import dispatchActionForAllModules from './store/initialize.stores';

import '@/core';
import '@/services/signalR';

Vue.use(Layout);

Vue.config.productionTip = false;

// Automatically run the `init` action for every module,
// if one exists.
dispatchActionForAllModules('Init').finally(() => {
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
});
